/**
 * Formata o tempo relativo entre duas datas para português do Brasil.
 * Retorna expressões como "agora" ou "há 3 dias" para datas recentes.
 * Para períodos a partir de sete dias, retorna a data absoluta.
 *
 * @param now - Data de referência (normalmente a data atual).
 * @param time - Data a ser comparada com a referência.
 * @returns String com o tempo relativo formatado.
 */
function formatRelativeTime(now: Date, time: Date): string {
  const relativeTimeFormatter = new Intl.RelativeTimeFormat("pt-BR", {
    numeric: "always"
  });

  const msPerMinute = 1000 * 60;
  const msPerHour = msPerMinute * 60;
  const msPerDay = msPerHour * 24;
  const msPerWeek = msPerDay * 7;

  const difference = time.getTime() - now.getTime();
  const absoluteDifference = Math.abs(difference);

  if (absoluteDifference < msPerMinute) {
    return "agora";
  }

  if (absoluteDifference < msPerHour) {
    return relativeTimeFormatter.format(
      Math.trunc(difference / msPerMinute),
      "minute"
    );
  }

  if (absoluteDifference < msPerDay) {
    return relativeTimeFormatter.format(
      Math.trunc(difference / msPerHour),
      "hour"
    );
  }

  if (absoluteDifference < msPerWeek) {
    return relativeTimeFormatter.format(
      Math.trunc(difference / msPerDay),
      "day"
    );
  }

  return new Intl.DateTimeFormat("pt-BR", {
    day: "numeric",
    month: "short",
    ...(time.getFullYear() !== now.getFullYear() && { year: "numeric" })
  }).format(time);
}

export default formatRelativeTime;
